<template>
    <div class="ratings"
        v-if="fullstars > 0">
        <i v-for="(n, index) in fullstars"
            class="fa fa-star"></i>
        <i v-if="halfstar"
            class="fas fa-star-half-alt"></i>
        <i v-for="(n, index) in emptystars"
            class="fa fa-star-o"></i>
    </div>
</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'star-display',
    	props: {
    		stars: Number
    	},
    	data: function() {
    		return {
    			totalStars: 5
    		};
    	},
    	computed: {
    		fullstars: function() {
    			var fullStars = parseInt(this.stars) || 0;
    			var remaingStar = this.stars - parseInt(this.stars);
    			if (remaingStar >= 0.50) {
    				fullStars += 1;
    			}
    			return fullStars;
    		},
    		halfstar: function() {
    			/*0.21 to 0.49 half star*/
    			/*0.50 and above full star*/
    			var remaingStar = this.stars - parseInt(this.stars);
    			return ((remaingStar >= 0.21 && remaingStar <= 0.49) ? true : false);
    		},
    		emptystars: function() {
    			if (this.halfstar) {
    				return this.totalStars - (this.fullstars) - 1;
    			} else {
    				return this.totalStars - this.fullstars;
    			}
    		}
    	}
    };
</script>